import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpenNewWindowDirective } from './open-new-window.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [OpenNewWindowDirective],
  exports: [OpenNewWindowDirective]
})
export class OpenNewWindowModule {}
